export const PRODUCT_CAPTURE_ENDPOINTS = {
  PRODUCT: 'product/',
  PRODUCTS: 'products',
  LIFECYCLE_PRODUCTS: 'lifecycle-products',
  UNDERLYING_ASSETS: 'underlying-assets/calendars',
  TRADING_CALENDAR_LIST: 'trading-calendars/',
  KEY_DATES: 'resolvekeydates',
  CURRENCY: 'currencies',
  FEES: 'product-fees/',
  PRODUCT_GOVERNANCE: 'product-governance/',
  PRODUCT_GOVERNANCES: 'products-governances',
  GOVERNANCE_QUESTIONS: 'governance-questions',
  GOVERNANCE_ANALYTICS: 'governance-analytics',
  ANALYTICS_REPORTS: 'analytics-reports',
  ANALYTICS_TESTS: 'analytics-tests',
  IS_PRODUCT_ISIN_AVAILABLE: 'is-available',
  STATUS_AUDIT: 'audit',
  CHANGE_LIFECYCLE_STATUS: 'product/change-lifecycle-status',
  TERMINATE: 'product/terminate'
};
